import React from 'react';
import PropTypes from 'prop-types';
import Notification from 'common-ui-components/dist/components/Atoms/Notification';
import Modal from 'common-ui-components/dist/components/Atoms/Modal';
import Button from 'common-ui-components/dist/components/Atoms/Button';
import './ShoppingCartRemoveAllModal.scss';

const ShoppingCartRemoveAllModal = props => {
  const {
    removeItems,
    itemsNotSaved,
    removeAllItems,
    cancel,
    isModalRemoveAllOpen,
    setIsModalRemoveAllOpen,
    removeCart,
    unavailableIconUrl,
  } = props;
  const heading = () => <Notification title={removeItems} icon={unavailableIconUrl} />;

  const closeModal = () => {
    setIsModalRemoveAllOpen(false);
    removeCart(true);
  };
  const modalProps = {
    isOpen: Boolean(isModalRemoveAllOpen),
    className: 'modal__Content',
    onRequestClose: () => setIsModalRemoveAllOpen(false),
    shouldCloseOnOverlayClick: true,
    heading: heading(),
  };
  return (
    <Modal {...modalProps}>
      <>
        <div>{itemsNotSaved}</div>
        <div className="center-xs">
          <Button className="primary cart-modal-notification-button" {...{ onClick: closeModal }}>
            {removeAllItems}
          </Button>
          <Button
            className="text cart-remove-modal-cancel-btn"
            {...{ onClick: () => setIsModalRemoveAllOpen(false) }}
          >
            {cancel}
          </Button>
        </div>
      </>
    </Modal>
  );
};

ShoppingCartRemoveAllModal.propTypes = {
  removeItems: PropTypes.string,
  itemsNotSaved: PropTypes.string,
  removeAllItems: PropTypes.string,
  cancel: PropTypes.string,
  isModalRemoveAllOpen: PropTypes.bool,
  setIsModalRemoveAllOpen: PropTypes.func,
  removeCart: PropTypes.func,
  unavailableIconUrl: PropTypes.string,
};

ShoppingCartRemoveAllModal.defaultProps = {
  removeItems: '',
  itemsNotSaved: '',
  removeAllItems: '',
  cancel: '',
  unavailableIconUrl: '/static/images/attention.svg',
  isModalRemoveAllOpen: false,
  setIsModalRemoveAllOpen: () => {
    /* default setIsModalRemoveAllOpen handler */
  },
  removeCart: () => {
    /* default removeCart handler */
  },
};

export default ShoppingCartRemoveAllModal;
